import React, { Component } from 'react';

import { formatNumber, handleImageError } from '../../../base/common/utils';
import { getClass } from '../../../../utils/component-helpers';
import productService from '../product-service';

import Badge from './badge';

import placeholderImage from '../../../../images/product_placeholder.png';
import linkoutIcon from '../../../../images/icons/linkout.svg';
import Tooltip from '../../../misc/tooltip';

import './product.scss';

class Product extends Component {
  constructor(props) {
    super(props);

    this.service = productService;

    this.state = {
      showLinkout: false,
      hoverProduct: false,
    };
  }

  addTooltip(el, productLabel) {
    if (
      ['strategy-product', 'product-research', 'product-research-siblings'].includes(
        this.props.type,
      )
    ) {
      const size = this.props.type === 'product-research' ? 0.5 : 1;
      return new Tooltip(el, { text: productLabel, size });
    }
  }

  render() {
    const {
      product,
      selectProduct,
      selected,
      hiddenBorder,
      merchant,
      trackLinkOut,
      type,
    } = this.props;

    const productLabel = this.service.getProductLabel(product);

    const productLinkout = product.store_page_url ? (
      <img
        src={linkoutIcon}
        alt="link out"
        className={getClass('linkout-icon', {
          show: this.state.showLinkout,
        })}
      />
    ) : null;

    const productPrice =
      product.sale_percent > 5 ? (
        <div className="prices">
          <span className="value sale">{this.service.displayPrice(product, 'sale')}</span>
          <span className="value original">{this.service.displayPrice(product)}</span>
        </div>
      ) : (
        <span className="value">{this.service.displayPrice(product)}</span>
      );

    const purchasedWith =
      type === 'product-research' && this.state.hoverProduct ? (
        <div className="purchased-with">
          <span>Also purchased with</span>
          <span className="arrow-right"></span>
        </div>
      ) : null;

    const showStockBadge =
      !product.is_in_stock &&
      (['product-research', 'product-research-siblings'].includes(type) ||
        type === 'strategy-product');

    const stockBadge = showStockBadge ? (
      <div className={`stock-badge ${type !== 'strategy-product' ? 'right' : ''}`}>
        <span>Out of Stock</span>
      </div>
    ) : null;

    const badge = !stockBadge ? (
      <Badge
        product={product}
        currentTab={type !== 'product-research-siblings' ? this.props.currentTab : 'all'}
      />
    ) : null;

    const collectionsProduct = () => {
      const stockStatus = product.is_in_stock ? 'In Stock' : 'Out of Stock';
      const itemPrice =
        product.sale_price_usd && product.price_usd ? (
          <div className="collection-price">
            <span className="actual-price">${formatNumber(product.price_usd, 'currency')}</span>
            <span className="sale-price">${formatNumber(product.sale_price_usd, 'currency')}</span>
          </div>
        ) : null;

      return (
        <div className="collection-product-details">
          {itemPrice}
          <div className="stock-status">{stockStatus}</div>
        </div>
      );
    };

    const productInfo =
      type === 'strategy-product' ? (
        <div className="product-info">
          <div className="price">{productPrice}</div>
          <div className="product-stats">
            <div className="earnings">
              <div>
                $
                {formatNumber(
                  product.publisher_total_earnings,
                  'currency',
                  'publisher_total_earnings',
                )}
              </div>
              <div>Earnings</div>
            </div>
            <div className="clicks">
              <div>{formatNumber(product.clicks)}</div>
              <div>Clicks</div>
            </div>
            <div className="epc">
              <div>${formatNumber(product.publisher_epc, 'currency')}</div>
              <div>EPC</div>
            </div>
          </div>
        </div>
      ) : type === 'collections' ? (
        collectionsProduct()
      ) : (
        <div className="product-info">
          <div className="price">
            {productPrice}
            {badge}
            <span className="description">{merchant ? `at ${merchant.short_name}` : ''}</span>
          </div>
          <div className="quantity">
            <span className="value">{formatNumber(product.total_quantity)}</span>
            <span className="description">Purchased</span>
          </div>
        </div>
      );

    const logoUrl = this.props.logoUrl || (merchant && merchant.logo_url);
    const imageUrl = product.image_url || logoUrl || placeholderImage;
    return (
      <div
        onClick={selectProduct}
        className={getClass(`product ${type}`, {
          selected,
          'hidden-border': hiddenBorder,
          hover: this.state.hoverProduct,
        })}
      >
        {stockBadge}
        <div
          className="image-container"
          onMouseEnter={() => this.setState({ showLinkout: true })}
          onMouseLeave={() => this.setState({ showLinkout: false })}
          onClick={trackLinkOut ? () => trackLinkOut(product.store_page_url) : () => {}}
        >
          <a href={product.store_page_url} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              className={`${type !== 'collections' ? 'product-image' : 'collection-img'}`}
              alt={`${productLabel}`}
              onError={e => handleImageError(e, logoUrl)}
            />
            {productLinkout}
          </a>
        </div>
        <div
          className="product-metadata"
          onMouseEnter={() => this.setState({ hoverProduct: true })}
          onMouseLeave={() => this.setState({ hoverProduct: false })}
        >
          <h3 className="product-label" ref={node => this.addTooltip(node, productLabel)}>
            {productLabel}
          </h3>
          {productInfo}
        </div>
        {purchasedWith}
        <div className="arrow-container">
          <span className="arrow"></span>
        </div>
      </div>
    );
  }
}

export default Product;
